import(/* webpackMode: "eager" */ "/vercel/path0/src/app/manufacturer-directory/page.tsx");
